import { createFileRoute } from '@tanstack/react-router'
import { Forecast } from '../screens/Forecast'
import { useAppState } from '../app-state'
import { RoleGuard } from '../components/RoleGuard'

function ForecastRoute() {
  const { railSelected } = useAppState()
  return (
    <RoleGuard>
      <Forecast railSelected={railSelected} />
    </RoleGuard>
  )
}

export const Route = createFileRoute('/forecast')({
  component: ForecastRoute,
})
